import React from 'react';
import styles from './styles.module.scss';

function Success() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper__success}>
        <h2 className={styles.wrapper__success__title}>
          You’re on your way to becoming a highly paid blockchain developer
        </h2>
        <ol className={styles.wrapper__success__text}>
          <li>Mark your calendar for Thursday, May 15th, 2025</li>
          <li>
            Go check your email right now. I just sent you an
            email with a special link to &quot;Confirm your spot&quot;.
            Make sure you click that link so that I know to
            look for you.
          </li>
          <li>
            To ensure that you receive all future announcements,
            make sure to check the promotions tab, and move the
            first email to your primary inbox.
          </li>
          <li>
            Keep an eye out because I’m going to send you more
            important emails about the big launch event soon!
          </li>
        </ol>
        <p className={styles.wrapper__success__text}>
          I’ll see you inside,
          <br />
          - Gregory
          <br />
          <small>Founder, Dapp University</small>
        </p>
      </div>
      <div className={styles.wrapper__success__image}>
        <span>🚀</span>
      </div>
    </div>
  );
}

export default Success;
